<template>
  <div class="content">
    <bmap></bmap>
  </div>
</template>
<script>
import bmap from '@/components/Bmap.vue'
export default {
  components: {
    bmap
  },
  data () {
    return {}
  }
}
</script>
<style lang='less' scoped>
.content {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>